import React from "react";
import { Grid } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import {
  Heading2,
  Body2,
} from "../../../components/value-cssmodules/TextComponent";
import styles from "./Help.module.scss";

const Help = () => {
  return (
    <section className={styles.help}>
      <Grid padded>
        <Grid.Row columns={1}>
          <Grid.Column>
            <Heading2>
              <FormattedMessage
                id={"nav.headingHelpDHP"}
                defaultMessage={"We are here to help"}
              />
            </Heading2>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={1}>
          <Grid.Column>
            <Body2>
              <FormattedMessage
                id={"nav.bodyHelpDHP"}
                defaultMessage={
                  "If you have any questions or need help, please contact with us ;D"
                }
              />
            </Body2>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </section>
  );
};

export default Help;
